<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useUISettings } from 'dashboard/composables/useUISettings';

import { masifiHomeView } from 'dashboard/helper/masifi/masifiHomeView';
import FormSelect from 'v3/components/Form/Select.vue';

// Masifi: mounted with no props by the profile page (touchpoint = import + register + tag); reads its own texts.
const { t } = useI18n();
const label = computed(() =>
  t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.DEFAULT_VIEW.TITLE')
);
const description = computed(() =>
  t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.DEFAULT_VIEW.NOTE')
);
const { updateUISettings, uiSettings } = useUISettings();

const options = computed(() => [
  {
    value: 'leads',
    name: t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.DEFAULT_VIEW.LEADS'),
  },
  {
    value: 'conversations',
    name: t(
      'PROFILE_SETTINGS.FORM.INTERFACE_SECTION.DEFAULT_VIEW.CONVERSATIONS'
    ),
  },
]);

const selectedValue = computed({
  // The shared masifiHomeView rule decides what the app opens; the select shows that same choice.
  get: () =>
    masifiHomeView({ ui_settings: uiSettings.value }) === 'dashboard'
      ? 'conversations'
      : 'leads',
  set: async value => {
    try {
      await updateUISettings({ default_home_view: value });
      useAlert(
        t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.DEFAULT_VIEW.UPDATE_SUCCESS')
      );
    } catch (error) {
      useAlert(
        t('PROFILE_SETTINGS.FORM.INTERFACE_SECTION.DEFAULT_VIEW.UPDATE_ERROR')
      );
    }
  },
});
</script>

<template>
  <div class="flex items-start justify-between w-full gap-2">
    <div>
      <label class="text-sm font-medium leading-6 text-n-gray-12">
        {{ label }}
      </label>
      <p class="text-n-gray-11">{{ description }}</p>
    </div>
    <FormSelect
      v-model="selectedValue"
      name="default_home_view"
      spacing="compact"
      class="min-w-28 mt-px"
      :options="options"
      label=""
    >
      <option
        v-for="option in options"
        :key="option.value"
        :value="option.value"
        :selected="option.value === selectedValue"
      >
        {{ option.name }}
      </option>
    </FormSelect>
  </div>
</template>
